import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";
import { useTheme } from '@material-ui/core';
import FilterListIcon from '@mui/icons-material/FilterList';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);



export const ChartsDate = () => {
    const theme = useTheme();

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: 'Tickets',
                position: 'left',
                color: theme.mode === 'light' ? 'inherit' : 'hsl(0, 0%, 95%)',
            },
            datalabels: {
                display: true,
                anchor: 'start',
                offset: -30,
                align: "start",
                color: "#fff",
                textStrokeColor: "#000",
                textStrokeWidth: 2,
                font: {
                    size: 20,
                    weight: "bold"
                },
            }
        },
        animation: {
            duration: 1000,
            easing: 'easeInOutQuad',
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: theme.mode === 'light' ? 'inherit' : 'hsl(270, 10%, 60%)',
                },
                grid: {
                    color: theme.mode === 'light' ? 'rgba(0, 0, 0, 0.1)' : 'hsl(270, 15%, 18%)',
                },
            },
            x: {
                ticks: {
                    color: theme.mode === 'light' ? 'inherit' : 'hsl(270, 10%, 60%)',
                },
                grid: {
                    color: theme.mode === 'light' ? 'rgba(0, 0, 0, 0.1)' : 'hsl(270, 15%, 18%)',
                },
            },
        },
    };
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId]);

    // Cores sólidas para as barras
    const barColors = [
        '#FF6384', // Rosa
        '#36A2EB', // Azul
        '#FFCE56', // Amarelo
        '#4BC0C0', // Ciano
        '#9966FF', // Roxo
        '#FF9F40', // Laranja
        '#C9CBCF', // Cinza
    ];

    const dataCharts = {
        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
        datasets: [
            {
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item) => item.total),
                backgroundColor: ticketsData?.data.map((_, index) => barColors[index % barColors.length]), // Cores sólidas para cada barra
                borderColor: ticketsData?.data.map((_, index) => barColors[index % barColors.length]), // Bordas com as mesmas cores
                borderWidth: 1,
                hoverBackgroundColor: ticketsData?.data.map((_, index) => barColors[index % barColors.length]), // Cores ao passar o mouse
                hoverBorderColor: '#000', // Cor da borda ao passar o mouse
            },
        ],
    };

    const handleGetTicketsInformation = async () => {
        try {
            const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);
        } catch (error) {
            toast.error('Erro ao buscar informações dos tickets');
        }
    }

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {i18n.t("dashboard.users.totalAttendances")} ({ticketsData?.count})
            </Typography>

            <Grid container spacing={2}>
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={initialDate}
                            onChange={(newValue) => { setInitialDate(newValue) }}
                            label={i18n.t("dashboard.date.initialDate")}
                            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={finalDate}
                            onChange={(newValue) => { setFinalDate(newValue) }}
                            label={i18n.t("dashboard.date.finalDate")}
                            renderInput={(params) => <TextField fullWidth {...params} sx={{ width: '20ch' }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <Button
                        startIcon={<FilterListIcon />}
                        style={{
                            color: "white",
                            backgroundColor: theme.mode === 'light' ? "#1E90FF" : "hsl(270, 80%, 60%)",
                            boxShadow: "none",
                            borderRadius: "10px",
                            padding: "8px 24px",
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                        onClick={handleGetTicketsInformation}
                        variant='contained'
                    >
                        Filtrar
                    </Button>
                </Grid>
            </Grid>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px' }} />
        </>
    );
}